import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=470a40af&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=470a40af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a40af",
  null
  
)

export default component.exports